var _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6,
    cy: 14.4671,
    rx: 6,
    ry: 4.58824,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.78092 14.9896L2.15647 9.35152C1.57477 8.45659 0.478486 6.29087 0.746964 4.7874C0.881199 3.42264 2.07592 0.558873 5.78092 0.0219175C7.25755 -0.134695 10.6135 0.492385 11.6874 3.72012C12.1668 5.16082 12.1707 6.70724 11.1505 8.21071L6.85484 14.9896C6.64065 15.2132 6.12599 15.5263 5.78092 14.9896ZM6.41076 8.05507C7.85646 8.05507 9.02842 6.8831 9.02842 5.43741C9.02842 3.99172 7.85646 2.81975 6.41076 2.81975C4.96507 2.81975 3.79311 3.99172 3.79311 5.43741C3.79311 6.8831 4.96507 8.05507 6.41076 8.05507Z",
    fill: "#4ABC48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransit);
export default __webpack_public_path__ + "static/media/transit.3e471d08a641e3679b52ee826e642921.svg";
export { ForwardRef as ReactComponent };